import { ValidationStatus } from '../store/global-types/customization-types';

/** PatternFly-compatible validated prop values.
 * Kept as a string union (not an enum) because these values are passed directly to PatternFly component props
 * which expect string literals. PatternFly's own types use string unions, so matching their convention avoids
 * conversion friction at every component call site.
 */
export type PatternFlyValidated = 'default' | 'success' | 'warning' | 'error';

// Named constants for PatternFlyValidated values
export const VALIDATION_DEFAULT: PatternFlyValidated = 'default';
export const VALIDATION_SUCCESS: PatternFlyValidated = 'success';
export const VALIDATION_WARNING: PatternFlyValidated = 'warning';
export const VALIDATION_ERROR: PatternFlyValidated = 'error';

/** UI field validation display state: a PatternFly validated value paired with helper text. */
export type FieldValidationState = { validated: PatternFlyValidated, helperTextInvalid: string | null };

/** Default empty validation (no error, no helper text). */
export const defaultValidation: FieldValidationState = { validated: 'default', helperTextInvalid: null };

/** Converts a ValidationStatus (sidebar/section domain) to a PatternFly validated string. Valid → 'default' (no visual feedback). */
export const validationStatusToPatternFly = (status: ValidationStatus): PatternFlyValidated => {
    switch (status) {
        case ValidationStatus.Error: return 'error';
        case ValidationStatus.Warning: return 'warning';
        case ValidationStatus.Valid: return 'default';
    }
};
